import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core'
import { productSubmitStatusEnum } from '../../models/products.enum'
import { SharedService } from 'src/app/shared/services/shared.service'
import { productListModel } from '../../models/products.model'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'
@Component({
	selector: 'app-products-table',
	templateUrl: './products-table.component.html',
	styleUrls: ['./products-table.component.scss'],
})
export class ProductsTableComponent implements OnInit {
	@Input() productsList!: productListModel[]
	@Input() totalCount!: number
	productStatsEnum = this.SharedService.returnEnumArray(productSubmitStatusEnum)
	@Input() productFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		countryId: 224,
		searchText: '',
		// status: 0,
		startDate: '',
		endDate: '',
	}
	arrowUp = true
	arrowDown = false
	attachmentUrl = environment.attachmentPath
	expandedProductId: number | null = null
	constructor(
		private SharedService: SharedService,
		public translate: TranslateService
	) {}
	ngOnInit(): void {}
	toggle(product: productListModel): void {
		if (this.expandedProductId === product.id) {
			this.expandedProductId = null // collapse if the same product is clicked again
		} else {
			this.expandedProductId = product.id // expand the clicked product
		}
	}
}
